import { cn } from '@dfh-corp-sites/ui/utils'
import React from 'react'

import { Metric } from '../../../../graphql/api'
import { useSanityRoleAndContextBasedContent } from '../../../../lib/sanity'

interface ItemMetricProps extends Metric {
  className?: string
}

const ItemMetric: React.FC<ItemMetricProps> = ({ className, title, roleBasedContent, value }) => {
  const { shouldDisplayContent } = useSanityRoleAndContextBasedContent()

  const shouldDisplay = roleBasedContent?.enabled
    ? shouldDisplayContent({
        roleBasedContent: { ...roleBasedContent, __typename: 'SanityRoleBasedContent' },
      })
    : true

  if (!shouldDisplay) {
    return null
  }

  return (
    <div className={cn(className)}>
      <p className="text-brand-navy-2 text-5xl border-b border-brand-rule-grey pb-3.5 xl:pb-3">
        {value}
      </p>
      <p className="text-base md:text-lg pt-3.5 xl:pt-3">{title}</p>
    </div>
  )
}

export default ItemMetric
